import { render, staticRenderFns } from "./SimpleFooter.vue?vue&type=template&id=383d9dc0&scoped=true&"
import script from "./SimpleFooter.vue?vue&type=script&lang=js&"
export * from "./SimpleFooter.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFooter.vue?vue&type=style&index=0&id=383d9dc0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d9dc0",
  null
  
)

export default component.exports